import { isPermissionsEnabled } from '~/components/core/Permissions/PermissionUtils';
import type { OrganizationModel } from '~/components/types/organization-types';
import type { UserModel } from '~/components/types/user-types';

interface QaCenterAvailabilityParams {
  user: Pick<UserModel, 'is_org_level_supervisor' | 'is_manager'>;
  organization: OrganizationModel;
  hasActivePerformanceQaForm: boolean | undefined;
}

/**
 * Whether the user can reach the Performance QA Center. The drawer link and the route both read this,
 * so the drawer never offers a link the router does not serve. Without an active QA form a review
 * would open an empty questionnaire, so the center is closed to everyone.
 */
export const isQaCenterAvailable = ({
  user,
  organization,
  hasActivePerformanceQaForm,
}: QaCenterAvailabilityParams): boolean =>
  Boolean(
    hasActivePerformanceQaForm &&
      (isPermissionsEnabled(organization) || user.is_org_level_supervisor || user.is_manager)
  );
